import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="m-0 text-center" >
        <div className="d-flex align-items-center p-4  justify-content-center  bg-light">
          <div className="col-md-6">
            <p className="m-0">Made with ❤️ by {" "} Balamurugan A
            </p>

          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
